var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepsdemo-content"},[_c('i',{staticClass:"pi pi-fw pi-user"}),_c('p',[_vm._v("Personal Component Content via Child Route")])])}]

export { render, staticRenderFns }